import { useQuery } from "@tanstack/react-query";
import { httpService } from "../../services/httpService";
import { API_CONFIG } from "../../shared/constants";
import { IRole } from "../../features/Configurations/RoleManagement/interface";

export const useRoles = () => {
  return useQuery<IRole[]>({
    queryKey: ["roles"],
    queryFn: async () => {
      const response = await httpService.get<IRole[]>(API_CONFIG.path.roles);
      return response;
    },
    staleTime: 24 * 60 * 60 * 1000, // 24 hours
    gcTime: 24 * 60 * 60 * 1000, // 24 hours
  });
};
